import { render, staticRenderFns } from "./NewsPress.vue?vue&type=template&id=5029afac&"
import script from "./NewsPress.vue?vue&type=script&lang=js&"
export * from "./NewsPress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports